import { axiosPrivate } from "./axios";

/**
 * Team presence from the Discord attendance bot (admins and squad leads).
 *  - getPresence({ from, to }) → { rows, today, timeZone, generatedAt }
 *    one row per member per day, same data as the bot's CSV export.
 *  - getLiveStatus() → { people: [{ userId, displayName, status, since }], online, today }
 *    status: "working" | "idle" | "offline" right now (idle comes from the bot).
 */
export const presenceService = {
  // scope: "team" → the Team Presence page view (admins: everyone; squad leads: their squads only)
  getPresence: async ({ from, to, scope }) => (await axiosPrivate.get("/api/presence/days", { params: { from, to, scope } })).data.data,
  getLiveStatus: async ({ scope } = {}) => (await axiosPrivate.get("/api/presence/live", { params: { scope } })).data.data,
  getAccess: async () => (await axiosPrivate.get("/api/presence/access")).data.data,
};

export default presenceService;
